export const isTablet = () => window.innerWidth >= 768 && window.innerWidth <= 1124;
